<template>
    <div class="link__group">
        <router-link class="" active-class="active" :to="{name: 'statistic'}">
            <span>{{ $t('statistics') }}</span>
        </router-link>
        <router-link class="" active-class="active" :to="{name: 'conversions'}">
            <span>{{ $t('conversions') }}</span>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "StatNav"
    }
</script>

<style>

    .link__group a:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }
    .link__group a.active {
        background-color: #429EFD;
        color: #fff;
        border-color: #429EFD;
    }
    .link__group a{
        font-size: 14px;
        line-height: 36px;
        padding: 0 40px;
        border: 1px solid #d9d9d9;
        background-color: #fff;
        display: inline-block;
        color: #354052;
        margin-right: -1px;
        font-weight: 500;
        outline: none;
        cursor: pointer;
        transition: color 0.3s;
        text-decoration: none !important;
    }

    .link__group a:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }
</style>